import { ResolveFn } from '@angular/router';
import { StrategyService } from '../services/strategy.service';
import { inject } from '@angular/core';
import { StrategicPillarService } from '../services/strategic-pillar.service';
import { GoalService } from '../services/goal.service';
import { forkJoin, map, Observable } from 'rxjs';

export const strategicPillarResolver: ResolveFn<Observable<any>> = (route, state) => {
  const strategyService = inject(StrategyService);
  const strategicPillarService = inject(StrategicPillarService);
  const goalService = inject(GoalService);
  const strategyId = route.params['strategyId'];
  return forkJoin({
    strategy: strategyService.getStrategyById(strategyId),
    pillars: strategicPillarService.getListPillars(strategyId),
    goalsResponse: goalService.getListGoals(strategyId)
  }).pipe(
    map(({ strategy, pillars, goalsResponse }) => ({
      strategy,
      pillars,
      goals: goalsResponse.goals,
      weight_summary: goalsResponse.weight_summary
    }))
  );
};
